// Get a message to indicate how long before a page load time a given event
// occurred. Uses the lowest-resolution time unit where there's a difference, starting
// with years and increasing resolution to minutes. Both timestamps should
// be expressed in ticks and the eventTime is assumed to be before the
// page load time
export function getRelativeTimestamp(pageLoadTimeTicks, eventTimeTicks) {
    // Translate both ticks timestamps into minutes since that's the finest
    // resolution we'll check for a relative timestamp
    const eventMins = eventTimeTicks / (10000 * 1000 * 60);
    const pageLoadMins = pageLoadTimeTicks / (10000 * 1000 * 60);

    const pageLoadHours = pageLoadMins / 60;
    const pageLoadDays = pageLoadHours / 24;
    const pageLoadWeeks = pageLoadDays / 7;
    const pageLoadYears = pageLoadWeeks / 52;

    const eventHours = eventMins / 60;
    const eventDays = eventHours / 24;
    const eventWeeks = eventDays / 7;
    const eventYears = eventWeeks / 52;

    let timeUnitAbbr;
    let timeUnitDiff;

    const yearDiff = pageLoadYears - eventYears;
    const weekDiff = pageLoadWeeks - eventWeeks;
    const dayDiff = pageLoadDays - eventDays;
    const hourDiff = pageLoadHours - eventHours;
    const minDiff = pageLoadMins - eventMins;

    if (weekDiff >= 52) {
        timeUnitAbbr = "y";
        timeUnitDiff = yearDiff;
    } else if (dayDiff >= 7) {
        timeUnitAbbr = "w";
        timeUnitDiff = weekDiff;
    } else if (hourDiff >= 24) {
        timeUnitAbbr = "d";
        timeUnitDiff = dayDiff;
    } else if (minDiff >= 60) {
        timeUnitAbbr = "h";
        timeUnitDiff = hourDiff;
    } else if (Math.floor(minDiff) > 0) {
        timeUnitAbbr = "m";
        timeUnitDiff = minDiff;
    } else {
        return "Just now";
    }

    return Math.floor(timeUnitDiff) + timeUnitAbbr + " ago";
}
